module.exports = __webpack_public_path__ + "static/media/4_2.bf7b71d4.png";